import { createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { setShowError } from "../../Common/Alerts/alertsSlice";
import { getAY } from "../../../../Utils/academivYear";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { getData, postData } from "../../../../services/apiEndpoints";


// Utility to format date for handling API errors and consistency
const formatDate = (date) => {
  const parsedDate = new Date(date);
  if (isNaN(parsedDate)) {
    console.warn("Invalid date value:", date);
    return new Date().toISOString().split("T")[0]; // Return current date if invalid
  }
  return parsedDate.toISOString().split("T")[0]; // Format valid date to YYYY-MM-DD
};

// Fetch attendance data by class, section, group, and date
export const fetchAttendanceByDate = createAsyncThunk(
  "staffAttendance/fetchAttendance",
  async (
    { date,startDate,endDate },
    { rejectWithValue, dispatch, getState }
  ) => {
    try {
      dispatch(setShowError(false));
      const say = getAY();
      const formattedDate = formatDate(date); 
      const formattedStartDate = formatDate(startDate); 
      const formattedEndDate = formatDate(endDate); 

      const response = await getData(
        `/teacher/attendance/staff/AttendanceByDateRange?say=${say}`,

        {date: formattedDate ,startDate:formattedStartDate,endDate:formattedEndDate} 
      );

      return response; 
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue); 
    }
  }
);

// Mark attendance
export const markStaffAttendance = createAsyncThunk(
  "staffAttendance/StaffAttendance",
  async (attendanceData, { rejectWithValue, dispatch, getState }) => {
    try {
      dispatch(setShowError(false));
      const say = getAY();
      const formattedDate = formatDate(attendanceData.date); // Format the date

      const response = await postData(
        `/teacher/attendance/staff/mark?say=${say}`,
        { ...attendanceData, date: formattedDate }
      );
      toast.success("Attendance marked ");
      dispatch(
        fetchAttendanceByDate({
          date: attendanceData.date,
        })
      ); // Fetch updated attendance data
      dispatch(setShowError(false));
      return response; // Return the response data
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue); // Centralized error handling
    }
  }
);


export const fetchStaffAttendanceStats = createAsyncThunk(
  "staffAttendance/fetchStaffAttendanceStats",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      dispatch(setShowError(false));
      const say = getAY();

      const response = await getData(
        `/teacher/attendance/staff/getAttendanceStats?say=${say}`
      );

      return response; // Return the response data
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Fetch Staffs' monthly attendance list by class, section, group, year, and month
export const fetchStaffsMonthAttendanceList = createAsyncThunk(
  "staffAttendance/fetchStaffsMonthAttendanceList",
  async (
    {  year, month },
    { rejectWithValue, dispatch, getState }
  ) => {
    try {
      dispatch(setShowError(false));
      const say = getAY();
      const response = await getData(
        `/teacher/attendance/staff/getStudentMonthList?say=${say}`,

        { year, month }
      );
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);
export const fetchStaffAttendanceYearlyStats = createAsyncThunk(
  "staffAttendance/fetchStaffAttendanceYearlyStats",
  async ({ fromDate, toDate,staffId, status }, { rejectWithValue, dispatch, getState }) => {
    try {
      dispatch(setShowError(false));
      
      const say = getAY();

      // Construct query string properly
      const queryParams = new URLSearchParams({
        say,
        ...(fromDate ? { fromDate } : {}),
        ...(toDate ? { toDate } : {}),
        ...(status ? { status } : {}),
        staffId
      });

      const response = await getData(
        `teacher/attendance/staff/getAttendanceYearlyStats?${queryParams.toString()}`
      );

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

